<template>
  <div class="row mb-3" v-if="steps.length">
    <div
      class="col-3"
      v-for="(step, index) in steps" :key="`step-${index}`"
    >
      <div class="step-wrapper">
        <span class="step-number">{{step.numeroPaso}}</span>
        <div class="text-center step-name">
          {{ step.responsable }}
          <div>
            <small v-if="step.desdePrecio">
              <b>{{ step.desdePrecio }} {{ step.desdePrecioMoneda }}</b>
            </small>
          </div>
        </div>
        <div class="step-type">
          <span v-if="step.distributed == 1" v-b-tooltip="'Distribuido: se asigna a 1 persona del grupo secuencialmente'" class="mr-1">
            <vs-icon icon="share" size="12px" color="warning" />
          </span>
          <span v-if="step.aprobacionesTipoPasoId === stepTypes.USER.toString()">
            usuario
          </span>
          <span v-if="step.aprobacionesTipoPasoId === stepTypes.OFFICE.toString()">
            oficina
          </span>
          <span v-if="step.aprobacionesTipoPasoId === stepTypes.GROUP.toString()">
            grupo
          </span>
          <span v-if="step.aprobacionesTipoPasoId === stepTypes.USER_SEND_APPROVAL.toString()">
            usuario<br />aprobación
          </span>
          <span
            v-if="step.aprobacionesTipoPasoId === stepTypes.LEADERSHIP_SENDING_APPROVAL.toString()"
          >
            J. usuario<br />aprobación
          </span>
          <span
            v-if="step.aprobacionesTipoPasoId
            === stepTypes.GROUP_LEADER_SENDING_APPROVAL.toString()"
          >
            L. usuario<br />aprobación
          </span>
          <span
            v-if="step.aprobacionesTipoPasoId
            === stepTypes.PERSON_FROM_DOC_PRE_DEFINED.toString()"
          >
            Desde <br />Archivo
          </span>
        </div>
        <div class="step-rol">
          <span v-if="step.aprobacionesTipoRolId === rolTypes.APPROVER.toString()">
            aprobador
          </span>
          <span
            v-if="step.aprobacionesTipoRolId === rolTypes.SIGNER.toString()
             && step.aprobacionesTipoPasoId !== stepTypes.OFFICE.toString()"
          >
            firmante
          </span>
          <span
            v-if="step.aprobacionesTipoRolId === rolTypes.SIGNER.toString()
             && step.aprobacionesTipoPasoId === stepTypes.OFFICE.toString()"
          >
            Numerar/tramitar
          </span>
          <span v-if="step.aprobacionesTipoRolId === rolTypes.CONFIGURATOR.toString()">
            configurador
          </span>
          <span v-if="step.aprobacionesTipoRolId === rolTypes.REVIEWER.toString()">
            revisor
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';

export default {
  data() {
    return {
      rolTypes: RolTypes,
      stepTypes: StepTypes
    };
  },
  props: {
    steps: {
      type: Array,
      required: true
    }
  }
};
</script>
<style>

.step-wrapper {
  border: 1px solid #662483;
  padding: 10px;
  border-radius: 5px;
  position: relative;
  margin-top: 20px;
}

.step-number {
  position: absolute;
  top: -10px;
  left: -4px;
  padding: 2px 8px;
  background: #16c86b;
  border-radius: 50%;
  color: white;
  font-size: 12px;
}

.step-delete {
  position: absolute;
  top: -10px;
  right: -4px;
  font-size: 10px;
  color: #b11e0b;
  cursor: pointer;
}

.step-rol {
  position: absolute;
  bottom: -10px;
  right: -1px;
  padding: 2px 8px;
  background: #671e85;
  border-radius: 5px;
  color: white;
  font-size: 12px;
}

.step-type {
  position: absolute;
  bottom: -10px;
  left: -1px;
  padding: 2px 8px;
  background: #155f87;
  border-radius: 5px;
  color: white;
  font-size: 12px;
}

.step-name {
  padding: 8px 0;
}
</style>
